import { Check } from 'lucide-react';

interface RolloutSectionProps {
  features: string[];
}

export function RolloutSection({ features }: RolloutSectionProps) {
  return (
    <div className="bg-[#F5F8F9] rounded-xl p-6 xs:p-8 sm:p-10 md:p-12 lg:p-16 xl:p-20 h-full">
      <h2 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl font-bold text-[#1D2125] mb-4 xs:mb-5 sm:mb-6">
        Roll out calmly
      </h2>
      <div className="space-y-3 xs:space-y-4">
        {features.map((feature, index) => (
          <div key={index} className="flex items-start gap-3 xs:gap-4">
            <Check className="h-4 xs:h-4.5 sm:h-5 w-4 xs:w-4.5 sm:w-5 text-[#0D373D] flex-shrink-0 mt-0.5" strokeWidth={2.5} />
            <p className="text-sm xs:text-base text-[#1D2125] flex-1">{feature}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

